// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProgramsPage from './pages/ProgramsPage';
import ProgramDetailPage from './pages/ProgramDetailPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import EventRegistrationPage from './pages/EventRegistrationPage';
import SuccessStoriesPage from './pages/SuccessStoriesPage';
import GalleryPage from './pages/GalleryPage';
import BlogPostDetailPage from './pages/BlogPostDetailPage';
import ResourcesPage from './pages/ResourcesPage';
import ApplyPage from './pages/ApplyPage';
import ApplySuccessPage from './pages/ApplySuccessPage';
import AdminRegistrationsPage from './pages/AdminRegistrationsPage';
import CoursePaymentPage from './pages/CoursePaymentPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminProgramsPage from './pages/AdminProgramsPage';
import AdminProgramStudentsPage from './pages/AdminProgramStudentsPage';
import AdminProtectedRoute from './components/admin/AdminProtectedRoute';

import './assets/css/index.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<AdminProtectedRoute><AdminDashboardPage /></AdminProtectedRoute>} />
        <Route path="/admin/registrations" element={<AdminProtectedRoute><AdminRegistrationsPage /></AdminProtectedRoute>} />
        <Route path="/admin/programs" element={<AdminProtectedRoute><AdminProgramsPage /></AdminProtectedRoute>} />
        <Route path="/admin/programs/:programId" element={<AdminProtectedRoute><AdminProgramStudentsPage /></AdminProtectedRoute>} />

        <Route
          path="*"
          element={(
            <MainLayout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/programs" element={<ProgramsPage />} />
                <Route path="/programs/:programId" element={<ProgramDetailPage />} />
                <Route path="/events" element={<EventsPage />} />
                <Route path="/events/:eventId" element={<EventDetailPage />} />
                <Route path="/events/register/:eventId" element={<EventRegistrationPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/success-stories" element={<SuccessStoriesPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                <Route path="/blog/:blogId" element={<BlogPostDetailPage />} />
                <Route path="/apply" element={<ApplyPage />} />
                <Route path="/apply/success" element={<ApplySuccessPage />} />
                <Route path="/pay-courses" element={<CoursePaymentPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </MainLayout>
          )}
        />
      </Routes>
    </Router>
  );
}

export default App;
